import ResourceService from './resource.service'
import Vue from 'vue'
class PricingListService extends ResourceService {
  static get resource() {
    return 'pricing-list'
  }

  static exportPricinglist(params = {}) {
    const url = `${this.resource}/download`
    return new Promise((resolve, reject) => {
      Vue.axios
        .get(url, {
          responseType: 'blob',
          params,
        })
        .then(({ data }) => {
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

export default PricingListService
